"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-4">
        <li className="h-4 w-32 bg-muted animate-pulse" />
        <li className="h-4 w-28 bg-muted animate-pulse" />
        <li className="h-4 w-36 bg-muted animate-pulse" />
        <li className="h-4 w-24 bg-muted animate-pulse" />
      </ul>;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default font-normal text-sm text-foreground hover:text-primary transition-colors duration-[220ms]" style={{
        letterSpacing: "-0.005em"
      }}>
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function RegulatoryDisclosure() {
  const elsewhereLinks = [{
    label: "LinkedIn",
    href: "#"
  }, {
    label: "Twitter",
    href: "#"
  }, {
    label: "Medium",
    href: "#"
  }, {
    label: "Email",
    href: "mailto:contact@advisoryfirm.com"
  }];
  return <section data-section-id="1605" id="regulatory-disclosure" className="relative w-full bg-background text-foreground pt-32 pb-12 font-default">
      <div className="max-w-[1440px] mx-auto px-6 md:px-16 lg:px-24">
        <p className="font-default font-normal text-muted-foreground text-sm leading-relaxed max-w-4xl">REGULATORY DISCLOSURE<br />Securities transactions described herein were effected through GT Securities, Inc. (GTS), a registered broker-dealer and member of FINRA/SIPC. Blue Phoenix Ventures (BPV) is the advisory brand under which the BPV team operates in association with GTS. All securities-related advisory services rendered in connection with these transactions were conducted by GTS-registered personnel. Blue Phoenix Ventures is not a registered broker-dealer; securities activities are conducted exclusively through GT Securities, Inc. Check the background of this firm on FINRA's BrokerCheck at brokercheck.finra.org.<br /><br /></p>
      </div>
    </section>;
}